/**
 * Hook for loading and saving application settings from IndexedDB.
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { loadSettings, saveSettings } from '@/lib/stockDb';
import type { AppSettings } from '@/types/stock';

export function useAppSettings() {
  return useQuery({
    queryKey: ['app-settings'],
    queryFn: () => loadSettings(),
    staleTime: Infinity,
  });
}

export function useSaveAppSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (settings: AppSettings) => {
      await saveSettings(settings);
      return settings;
    },
    onSuccess: (settings) => {
      queryClient.setQueryData(['app-settings'], settings);
    },
  });
}
